import React, {Fragment,Component,useState,useEffect} from 'react';
import axios from 'axios';
import {connect} from 'react-redux';
import Iframe from "react-iframe"
import { Redirect,Link } from 'react-router-dom';
import { Table,Placeholder } from 'semantic-ui-react';
import {
  Menu,
  Segment,
  Container,
  Divider,
  Message,
  Icon,
  Header,
  Dimmer,
  Responsive,
  Modal,
  Button,
  Image,
  Loader,
  Tab,
  Label
} from 'semantic-ui-react';
import Clipboard from 'react-clipboard.js';

function Guide(props){

  const [synchronized, setSynchronized] = useState(true);
  const [current, setCurrent] = useState(0);

  const {t}       = props;
  const mobile    = /Android|iPhone|iPod/.test(navigator.userAgent);
  const title     = props.data.title;
  const port      = props.data.port;
  const password  = props.data.password;
  const code      = props.data.code;
  const hashed    = props.data.hashed;
  const user_id   = props.data.user_id;
  const user_vip  = props.data.user_vip;

  const macDownload         = "https://glados.rocks/tools/ClashX.dmg";

  //subscribe_endpoint = "update.glados-config.net";
  //subscribe_endpoint = "update.glados-config.org";
  var subscribe_endpoint = "update.glados-config.com";

  const suburl           = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados.yaml`
  const singbox          = "https://apps.apple.com/us/app/sing-box/id6451272673";
  const singurl          = `https://${subscribe_endpoint}/singbox/${user_id}/${hashed}`

  var panes = [{

      desktop:true,
      menuItem:<Menu.Item key='pro3'>
        ClashX<Label color="green">BEST</Label>
      </Menu.Item>,
      render: () => {
        return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>

          <p style={{color:"black"}}>1. 点击下载 <a  href={macDownload}>ClashX 客户端</a>, 安装 ClashX</p>
          <p>2. 运行 ClashX 后，<button><a href={`clash://install-config?url=https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados.yaml&name=GLaDOS`}>左键点击这里添加订阅</a></button> 备注填写 GLaDOS</p>
          <p>3. 点击屏幕最右上方的 ClashX 菜单，勾选设为系统代理(set System Proxy) </p>
          <p>4. 用浏览器打开 Google.com</p>
          <p>如果第二步 ClashX 没有响应，请手动添加Clash订阅地址 
            <Clipboard
              style={{"borderRadius": "5px", "padding": "4px"}}
              onSuccess={()=>{ setClipboard(true) }}
              data-clipboard-text={suburl}>
              { clipboard ? "copied" : "copy to clipboard" }
            </Clipboard> {suburl}</p>
          <p>开源项目地址 https://github.com/yichengchen/clashX/releases</p>
          <p>ClashX 注意事项:</p>
          <ul>
            <li>默认使用Rule模式，不要改为全局或直接连接</li>
            <li>推荐设置系统代理和开机运行。</li>
            <li>打开自动更新功能</li>
          </ul>
          <p>您也可以使用专业版 ClashX Pro <a href="https://install.appcenter.ms/users/clashx/apps/clashx-pro/distribution_groups/public">下载</a></p>
          <p>
            <b>ClashX Pro</b> 支持增强模式, 开启增强模式(Enhanced Mode)可以让其他软件不设置代理就可以通过代理发送网络请求
          </p>
          <p>增强模式可以实现:</p>
          <ul>
            <li>1. 加速命令行程序，如 GIT/GO/NPM 等开发工具</li>
            <li>2. 加速非浏览器程序，如Line/Telegram</li>
          </ul>

          <p>如果遇到问题, 请进入<Link to="/console/client">诊断页面</Link>确保状态为全部绿色，如果仍然无法使用请联系客服</p>
        </Tab.Pane>)
      }
      },{
      desktop:true,
      menuItem:<Menu.Item key='pro3'>
        SingBox For Mac
      </Menu.Item>,
      render: () => {
        return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>

                      <Message id="m4" info style={{boxShadow:"none"}}>
                        <Message.Header>Singbox 客户端不稳定提示</Message.Header>
                        <p>由于 Singbox 正在开发早期，很多功能会不稳定。如果遇到故障, 我们推荐您使用其他客户端。</p>
                      </Message>

                        <p>1. 通过 <a href="https://apps.apple.com/us/app/sing-box/id6451272673">AppStore</a> 安装 Singbox Mac 版</p>
                        <p>2. 复制配置文件URL:

            <Clipboard
              style={{"borderRadius": "5px", "padding": "4px"}}
              onSuccess={()=>{ setClipboard(true) }}
              data-clipboard-text={singurl}>
              { clipboard ? "copied" : "copy to clipboard" }
            </Clipboard> {singurl}</p>

                        <p>3. 在 Singbox 里添加订阅</p>
                        <p>4. 点击开始</p>

                        <p>项目开源地址: https://sing-box.sagernet.org/</p>
        </Tab.Pane>)
      }
    },{
      desktop:true,
      menuItem:<Menu.Item key='pro3'>
        Stash For Mac
      </Menu.Item>,
      render: () => {
        return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>

            <p>1. 通过 https://stash.ws/macos/pricing 购买后安装 Stash Mac 版</p>
            <p>2. 初次运行 Stash 允许 Stash 的安装请求</p>
            <p>3. 点击右上角 Stash 图标，选择 Control Panel</p>
            <p>4. 复制配置文件URL 
            <Clipboard
              style={{"borderRadius": "5px", "padding": "4px"}}
              onSuccess={()=>{ setClipboard(true) }}
              data-clipboard-text={singurl}>
              { clipboard ? "copied" : "copy to clipboard" }
            </Clipboard> {singurl}</p>
            <p>5. 选择 Config File 选择 install from url 粘贴URL</p>
            <p>6. 选中下载的配置文件</p>
            <p>7. 点击Control Panel, 点击Set as System Proxy</p>
            <p>项目地址: https://stash.ws </p>
        </Tab.Pane>)
      }
    }
  ]

  const [clipboard,setClipboard] = useState(false);

  useEffect(()=>{
    if(clipboard == true){
      setTimeout(()=>{
        setClipboard(false)
      },3000)
    }
    return ()=>{ }
  },[clipboard])

  return (
  <Fragment>

    <Header as='h2' color="blue">
      {t("settings.mac.title")}
      <Header.Subheader>
      {t("settings.mac.notes")}
      </Header.Subheader>
    </Header>
    <p>{t("settings.clash.what")}</p>
    <p>{t("settings.clash.steps")}</p>
    <p>1.{t("settings.clash.step1")}</p>
    <p>2.{t("settings.clash.step2")}</p>
    <p>3.{t("settings.clash.step3")}</p>

    <Table>

      <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan='3'>
            MacOS
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        <Segment>
          <Tab  menu={{ color:"blue", secondary: true}} panes={panes} />
        </Segment>
      </Table.Body>
    </Table>
  </Fragment>
  )
}
export {Guide};
